import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cards from '../components/Cards'
import ProgressBar from '../components/ProgressBar'
import Navbar from '../components/Navbar';
import AdditionalBenefits from '../components/AdditionalBenefits.jsx';
import { createErrorEmail, saveMenu } from '../redux/reducer/stepReducer/thunks.js';
import { setAdditionalData, setAllSteps, setCodpmpol, setCurrentTab, setErrorEncrypt, setFirstStep, setFrequentQuestions } from '../redux/reducer/stepReducer/stepReducer.js';
import { CODEMP_CREDITO_ARGENTINO, CODEMP_MUSIMUNDO } from '../utilities/index.js';
import life from '../assets/life-small.svg'
import bbva from '../assets/bbva-small.svg'
import prudential from '../assets/prudential-small.svg'
import { benefits } from '../utilities/benefits.js';
import { Stack, Typography, Box, Grid } from '@mui/material';


const companies = [{ company: 1085, logo: life, size: '35%' }, { company: 88, logo: prudential, size: '35%' }, { company: 34, logo: bbva, size: '20%' }];
const HOGAR_SECTION = "8"
const PERSONAL_ACCIDENTS_SECTION = "12"


const View = () => {
  const [activeTab, setActiveTab] = useState(1);
  const { products, codemp } = useSelector(state => state.adminReducer.login);
  const { firstStep, codpmpol, userContainProduct, paramsMus } = useSelector((state) => state.firstStep);
  const planesToRender = products?.filter((e) => (e.section == firstStep.codsec && Number(e.price) !== 0));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log('planes', products)

  const onNextPage = async (tabNumber, codpro, price, plan, plapro) => {
    if (codpro && price && plan) await dispatch(setFirstStep({ codpro, price, plan, plapro, ...paramsMus, product: firstStep.codsec }));
    if (userContainProduct) await dispatch(saveMenu({ ...firstStep, codpro, price, plan, ...paramsMus }, codemp));
    localStorage.setItem('firstStep', JSON.stringify({ ...paramsMus, ...firstStep, codpro, price, plan, plapro }));
    dispatch(setCurrentTab(tabNumber));
    navigate('/datosTitular');
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = 'Estoy a punto de refrescarme';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    dispatch(setCurrentTab(1));
    dispatch(setAllSteps(1));
    dispatch(setAdditionalData(''));
  }, []);

  useEffect(() => {
    dispatch(setFrequentQuestions(firstStep.codsec))
  }, [firstStep.codsec]);


  useEffect(() => {
    if (!codpmpol && !userContainProduct) {
      try {
        const getLocalDateStorage = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
        const getLocalFirstStep = () => { return JSON.parse(localStorage.getItem('firstStep')) || [] };
        const storageCodpmpol = getLocalDateStorage();
        const storageFirstStep = getLocalFirstStep();
        //Si es un array es porque el storage no tiene un codpmpol
        if (Array.isArray(storageCodpmpol)) {
          let message = `Error Recid | View | Intencion: ${storageFirstStep.nro}`
          dispatch(createErrorEmail(message));
          dispatch(setErrorEncrypt(true))
          navigate('/error');
        }
        else {
          dispatch(setCodpmpol(storageCodpmpol));
          dispatch(setFirstStep(storageFirstStep));
        };
      } catch (error) {
        let message = `Error en View | ${error}`;
        dispatch(createErrorEmail(message));
        dispatch(setErrorEncrypt(true));
        navigate('/error');
      }
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('productType')) {
      dispatch(setFirstStep({ codsec: String(JSON.parse(localStorage.getItem('productType'))) }));
    };
  }, []);

  return (
    <Grid container display={'flex'} justifyContent={'center'} >
      <Grid item xs={12} justifyContent={'center'} height={"60px"} >
        <Navbar activeTab={activeTab} codpmpol={paramsMus.nro} />
      </Grid>
      <Grid item xs={12}>
        <div className="tab-content">
          {
            activeTab === 1 &&
            <div className='textHeader'>
              <h3 style={{ fontSize: '1.8rem', marginTop: '10px' }}>Elegí </h3>
              <h3 style={{ marginBottom: '10px', fontSize: '1.8rem' }}>entre los planes</h3>
              <p style={{ fontSize: '1rem' }}>Seleccioná el plan que más se adapte a </p>
              <p style={{ fontSize: '1rem' }}>tus necesidades y preferencias.</p>
            </div>
          }
          <div className="tabs">
            <div className='progressBar'>
              <ProgressBar activeTab={activeTab} firstStep={firstStep} />
              <div className="tabs_uno">
                <Stack style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', width: '100%', paddingLeft: "12px", paddingRight: "12px" }}>
                  <Box
                    style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '6px', fontSize: '0.688rem' }}
                    className={`tab ${activeTab === 1 && CODEMP_CREDITO_ARGENTINO.includes(codemp) ? 'active-cfn' : activeTab === 1 && CODEMP_MUSIMUNDO ? 'active' : ''}`}
                  >
                    Elegí
                  </Box>
                  <Box
                    style={{ fontSize: '0.688rem' }}
                    className={`tab ${activeTab === 2 && CODEMP_CREDITO_ARGENTINO.includes(codemp) ? 'active-cfn' : activeTab === 2 && CODEMP_MUSIMUNDO ? 'active' : ''}`}
                  >
                    Completá
                  </Box>
                  <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingRight: '6px', fontSize: '0.688rem' }}
                    className={`tab ${activeTab === 3 && CODEMP_CREDITO_ARGENTINO.includes(codemp) ? 'active-cfn' : activeTab === 3 && CODEMP_MUSIMUNDO ? 'active' : ''}`}
                  >
                    Contratá
                  </Box>
                </Stack>
              </div>
            </div>
          </div>
          {
            activeTab === 1 &&
            <div className='cardConteiner'>
              <Stack display={'flex'} justifyContent={'start'} flexDirection={'row'} marginRight={'5%'} margin={'10px'} width={'100%'}>
                <Typography gutterBottom variant="h5" component="div" style={{ fontFamily: 'Roboto', fontWeight: '300' }} sx={{ fontSize: 'small' }} marginRight={'5px'} >
                  Con el respaldo de
                </Typography>
                <img src={companies.find((e) => e.company === firstStep.codcia)?.logo} alt='logo' style={{ width: companies.find((e) => e.company === firstStep.codcia)?.size }} />
              </Stack>
              {
                planesToRender?.map((plan, index) => (
                  <Cards
                    key={index}
                    icono={plan.plapro}
                    codpro={plan.codpro}
                    plan={plan.plan}
                    price={plan.price}
                    details={plan.details}
                    onNextPage={onNextPage}
                    activeTab={activeTab}
                  />
                ))
              }
              {
                (firstStep.codsec === HOGAR_SECTION || firstStep.codsec === PERSONAL_ACCIDENTS_SECTION) &&
                <AdditionalBenefits benefits={benefits} />
              }
            </div>
          }
        </div>
      </Grid >
    </Grid>
  );
};

export default View;





